import { createContext } from 'react'

export interface FormElement {
  invalidRule: string
  isInput: boolean
  name: string
  value: string
}

export interface FormContextValue {
  formElements: FormElement[]
}

export const FormContext = createContext<FormContextValue | undefined>(
  undefined
)
